export default import.meta.ROLLDOWN_FILE_URL_x9IzUJ6pq32gOV4Wczuu7Q